module.exports = __webpack_public_path__ + "img/wochenblatt-pilgrim.1e94318f.jpg";